import React from 'react'

import { cn } from '@/shared/lib/utils'
import { formatNumber } from '@/shared/tools/locale'

export function BasicNumberField({
	value,
	ref,
	className,
}: {
	value: number | null | undefined
	ref?: React.Ref<HTMLDivElement>
	className?: string
}) {
	if (value === null || value === undefined) {
		return (
			<div ref={ref} className={cn('cell-data-number', className)}>
				-
			</div>
		)
	}

	return (
		<div ref={ref} className={cn('cell-data-number', className)}>
			{formatNumber(value)}
		</div>
	)
}
